<template>
  <el-drawer
  :title="$t('payments.billPaymentTitle')"
  :visible.sync="visible"
  :direction="direction"
  :before-close="handleClose"
  :size="width"
  @open="open"
  v-loading.fullscreen.lock="loading">
  <div class="drawer__content scrollable only-y" :style="divHeight" >
    <!-- <el-form :rules="rules" ref="reservationForm" :model="reservation"> -->
    <el-form label-position="top" :rules="rules" ref="paymentForm" :model="payment">
      <h4>{{$t('payments.billsToPay')}}</h4>
      <el-row :gutter="20">
        <el-table
          :data="invoices"
          style="width: 100%">
          <el-table-column
            prop="invNumber"
            :label="$t('invoices.invoiceNumber')"
            width="130">
          </el-table-column>
          <el-table-column
            prop="date"
            :label="$t('common.date')">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ _moment(scope.row.date,'L')}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="date"
            :label="$t('common.dueDate')">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ _moment(scope.row.dueDate,'L')}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="balance.outstanding"
            :label="$t('common.outstanding')">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ $n(scope.row.balance.outstanding,'currency', scope.row.currency.code != null ? scope.row.currency.code : 'CAD') }}</span>
            </template>
          </el-table-column>
        </el-table>
      </el-row>
      <el-divider/>
      <h4>{{ $t('payments.paymentInfo') }}</h4>
      <el-row :gutter="20">
        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
          <el-form-item :label="$t('payments.paymentAmount')">
              <el-tooltip :content="creditToolTipText" placement="right" :manual="true" v-model="isAmountOver">
               <el-input-number v-model="payment.amount" controls-position="right" :precision="2" :min="0" :max="maxPayment"></el-input-number>
             </el-tooltip>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
          <el-form-item :label="$t('payments.paymentMethod')" prop="paymentMethod">
            <el-select v-model="payment.paymentMethod" value-key="id" @change="handlePaymentModeChange">
              <el-option
                v-for="item in paymentMethodList"
                :key="item.id"
                :label="paymentLabel(item)"
                :value="item">
                <span v-if="item.type !== 'card'" style="float: left">{{ paymentLabel(item) }}</span>
                <span v-else>
                  <PaymentCardInfo :brand="item.card.brand" :last4="item.card.last4"/>
                </span>
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
          <el-form-item :label="$t('common.date')" prop="date">
            <el-date-picker
             :disabled="disableDateSelection"
              v-model="payment.date"
              type="date">
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
          <el-form-item :label="$t('common.reference')">
              <el-input v-model="payment.reference" ></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
          <el-form-item :label="$t('common.description')">
          <el-input type="textarea" :rows="2" :placeholder="$t('common.descriptionInstruction')" v-model="payment.description">  </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="dialog-footer card-shadow--large">
      <el-button @click="handleClose">{{$t('common.Cancel')}}</el-button>
      <el-button type="primary" @click="save" :disabled="loading">{{$t('common.save')}}</el-button>
    </div>
  </div>
</el-drawer>
</template>
<script>
import moment from 'moment-timezone'
import PaymentAPI from '@/services/API/payment.js'
import CustomerAPI from '@/services/API/customer.js'
import PaymentCardInfo from '@/components/payment-card-info'
import dayjs from 'dayjs'
import { mapGetters, mapState, mapActions } from 'vuex';

export default {
  name: 'AddPaymentsDialog',
	props: {
    visible : Boolean,
    invoices : Array,
    customerId : Number,
    direction:{
      type : String,
      Default : 'rtl'
    },
    paymentToEdit : Object

	},
  data() {
    return {
      paymentMethods : [],
      cards : [],
      credit : null,
      maxPayment : Infinity,
      stripe: null,
      payment : {
        paymentMethod : null,
        amount : 0.00,
        reference : null,
        description : null,
        date : null,
        automatic : false,
        credit : null,
        customerId : null,
      },
      timer: null,
      loading : false,
      // payments : [],
      rules: {
          paymentMethod: [
            { required: true, message: 'Veuillez saisir un mode de paiement', trigger: 'blur' }
          ],
          date: [
            { required: true, message: 'Veuillez saisir une date', trigger: 'blur' }
          ]
        },
      window: {
        width: 0,
        height: 0
      }
    };
  },components: {
    PaymentCardInfo,
  },
  watch : {

  },
	methods: {
    handlePaymentModeChange(newPayment){
      if (_.get(newPayment, 'type') === 'card') {
        this.payment.date = dayjs().format();
      }
      if(newPayment.code=="CREDIT_NOTE"){
        this.payment.amount=this.outstanding<this.credit ? this.outstanding : this.credit;
        this.maxPayment = this.outstanding<this.credit ? this.outstanding : this.credit;
      }else{
        this.maxPayment = Infinity;
      }
    },
    reset(){
      this.payment.paymentMethod = null;
      this.payment.amount = 0.00;
      this.payment.reference = null;
      this.payment.description = null;
      this.payment.date=null;
    },
    waitingForConfirmation(paymentId){
      PaymentAPI.getPayment(paymentId)
        .then(payment=>{
          if(payment.trx_detail!=null && payment.trx_detail.card!=null){
            this.paymentResponse = payment;
            this.cancelWaitingPayment();
            this.loading=false;
            this.$emit('paid', {payment, invoices:this.invoices});
            this.handleClose();
          }
        })
    },
    cancelWaitingPayment(){
      clearInterval(this.timer);
    },
    processCreditCardPayment () {
      this.loading = true;
      this.stripe = Stripe(this.stripePk);
      const postObj = {
        amount: this.payment.amount,
        currency: _.get(_.head(this.invoices), 'currency'),
        customer: {
          id: this.customerId,
        },
        reference : this.payment.reference,
        description : this.payment.description,
        invoices: _.map(this.invoices, inv => ({id: inv.id, invNumber: inv.invNumber})),
        portausCompanyId: this.portausCompanyId,
        methodPayment: this.payment.paymentMethod.id,
      }
      PaymentAPI.createStripePaymentIntent(postObj)
        .then((payment) => {
          let paymentIntent = payment.detail.intentPayment;
          this.stripe.confirmCardPayment(paymentIntent.client_secret, {
            payment_method: this.payment.paymentMethod.id,
            setup_future_usage: 'off_session',
          })
          .then((result) => {
            if (result.error) {
              this.loading = false;
              console.log(result.error);
            } else {
              this.timer = setInterval(() => this.waitingForConfirmation(payment.id), 1000);
            }
          })
        })

    },
    save(){
      this.loading=true;
      this.payment.customerId = this.customerId;
      if(this.isAmountOver){
        this.payment.credit = this.creditAmount;
      }

      this.$refs['paymentForm'].validate((valid) => {
        if(valid){
          if(!this.editionMode){
            if (this.offSessionCardPayment) {
              this.processCreditCardPayment();
            } else {
              PaymentAPI.processAdminPayment(this.payment, this.invoices)
              .then(payment=>{
                this.$emit('paid', {payment, invoices:this.invoices});
                this.handleClose();
                this.loading=false;
              })
            }
           
          }else{
            // PaymentAPI.editAdminPayment(this.payment);
          }

        }else{
          this.loading=false;
          return false;
        }
      })


    },
    _moment(datetime, format='LL'){
      return moment(datetime).format(format);
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    handleClose(){
      this.$emit('close');
      this.reset();
    },
    fetchPaymentTypes(){
      return PaymentAPI.listPaymentMethods({type:0, active:true})
        .then(paymentMethods=>{
          this.paymentMethods=paymentMethods;
          return paymentMethods;
        })
    },
    fetchPaymentMethods (customerId) {
      return PaymentAPI.getCustomerPaymentMethods(customerId, this.portausCompanyId)
        .then((cards) => {
          this.cards = cards;
        })
    },
    fetchCustomer(){
      return CustomerAPI.getCustomer(this.customerId)
        .then(customer=>{
          if(customer.balance_account!=null && customer.balance_account.credit>0){
            let creditNotePayment = _.find(this.paymentMethods, p=>{return p.code=="CREDIT_NOTE"});
            creditNotePayment.active=true;
            this.credit = customer.balance_account.credit;
          }
        })
    },
    open(){

      if(this.editionMode){
        this.payment.amount = this.paymentToEdit.amount;
        this.payment.date = this.paymentToEdit.date;
        this.payment.description = this.paymentToEdit.description;
        this.payment.reference = this.paymentToEdit.reference;
        this.payment.paymentMethod = _.cloneDeep(this.paymentToEdit.payment_type);
      }else{
        this.payment.amount = this.outstanding;

      }

      return Promise.all([this.fetchPaymentTypes(),this.fetchCustomer(), this.fetchPaymentMethods(this.customerId)])

    },
    paymentLabel(payment){
      if (_.get(payment, 'type') === 'card') {
        return `**** **** **** ${payment.card.last4} (${payment.card.brand})`;
      }

      if(payment.code=="CREDIT_NOTE"){
        return this.$i18n.t('invoices.ADMIN_'+payment.code, {credit:this.credit});
      }else{
        return this.$i18n.t('invoices.'+payment.code);
      }

    },
    ...mapActions('controlData', ['fetchPortausCompany'])
	},
	computed: {
    offSessionCardPayment () {
      return _.get(this.payment, 'paymentMethod.type') === 'card';
    },
    disableDateSelection () {
      return this.offSessionCardPayment;
    },
    paymentMethodList() {
      return [...this.cards, ...this.paymentMethods];
    },
    editionMode(){
      return this.paymentToEdit!=null;
    },
    isAmountOver:{
      set(amountOver){},
      get(){  if((this.paymentToEdit==null && this.payment.amount>this.outstanding)||
                 (this.paymentToEdit!=null && this.payment.amount>(this.outstanding+this.paymentToEdit.amount))){
          return true
        }else{
          return false;
        }}
    },
    creditAmount(){
      if(this.isAmountOver){
        let paymentMade = this.paymentToEdit==null ? 0.00 : this.paymentToEdit.amount;
        return Math.round((this.payment.amount-(this.outstanding+paymentMade))*100)/100;
      }
      return 0.0;
    },
    creditToolTipText(){
      return this.$i18n.t("payments.payment_over_add_credit_note", {credit:this.creditAmount})
    },
    paymentTypes(){
      let paymentTypes = [];
      _.forEach(this.paymentMethods, p=>{
        if(p.active)paymentTypes.push(p);
      })
      return paymentTypes;
    },
    outstanding(){
      let outstanding = 0.00;
      if(this.invoices!=null){
        _.forEach(this.invoices, invoice=>{
          outstanding += invoice.balance.outstanding
        })
      }

      return Math.round(outstanding * 100) / 100;
    },
    divHeight(){
      return "height :"+(this.window.height-130) + "px"
    },
    width(){
      // console.log("width :", this.window.width);
      if(this.window.width > 1024){
        return "50%";
      }else{
        return "100%"
      }

    },
    stripePk () {
      return _.get(_.find(this.portausCompanies, pc => pc.id === this.portausCompanyId), 'stripePublicKey');
    },
    ...mapGetters(['portausCompanyId']),
    ...mapState('controlData', ['portausCompanies'])


	},
  created(){
    window.addEventListener('resize', this.handleResize)
    this.handleResize();
    this.fetchPortausCompany();
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>
<style lang="scss" scoped>

.dialog-footer{
  position: fixed;
  display: block;
  bottom: 0px;
  width: 100%;
  background-color: #f3f7fa;
  height:50px;
  margin-left:-40px;
  padding-left:40px;
  padding-top:10px;
  border-top:1px solid #E4E7ED
}

.drawer__content {
  margin-left:40px;
  margin-right:20px;
}

@media (max-width: 1366px) {
  .formContainer{
      margin-left:10%;
      width:80%;
    }
}

@media (max-width: 1024px) {
  .formContainer{
      margin-left:2%;
      width:98%;
    }
}


</style>
